export const pagesProductRoadmapEn = {
  detail: {
    breadcrumb: {
      home: 'Home',
      list: 'Product Roadmap'
    },
    gantt: {
      barTypes: {
        close: 'Close',
        hotfix: 'Hotfix',
        release: 'Release',
        revert: 'Revert',
        update: 'Update'
      },
      phaseTabs: {
        all: 'All',
        confirmed: 'Confirmed',
        planned: 'Planned'
      },
      productStructure: 'Product structure',
      searchPlaceholder: 'Search product structure...'
    },
    preparing: 'Coming soon',
    tabs: {
      detail: 'Details',
      history: 'History'
    }
  },
  list: {
    columns: {
      confirmedAt: 'Confirmed at',
      itemCount: 'Items',
      product: 'Product',
      revision: 'Revision',
      status: 'Status'
    },
    empty: 'No roadmaps yet.',
    emptyValue: '—',
    itemUnit: 'items',
    revisionPrefix: 'rev. ',
    searchPlaceholder: 'Search by name...',
    tabs: {
      all: 'All'
    }
  },
  status: {
    archived: 'Archived',
    confirmed: 'Latest',
    draft: 'Draft'
  }
};